const http = require('../lib/httpClient');

const tenantCodeLookup = {
  'falabella-cl': 'cl',
  'falabella-pe': 'pe',
  'falabella-ar': 'ar',
  'falabella-co': 'co',
  'marketplace-cl': 'cl',
  'marketplace-pe': 'pe',
  'marketplace-ar': 'ar',
  'marketplace-co': 'co',
  'sodimac-cl': 'cl',
  'sodimac-pe': 'pe',
  'sodimac-mx': 'mx',
  'marketplacesodimac-cl': 'cl',
  'marketplacesodimac-pe': 'pe',
  'tottus-cl': 'cl',
  'marketplacetottus-cl': 'cl',
  'marketplacetottus-pe': 'pe',
  'tottus-pe': 'pe',
};

const endpointPattern = '/s/geo/v2/districts/{tenantCode}?politicalId=default&store=to_com';

async function getDefaultPoliticalIdWithLatLong(tenantId, catalystBaseUrl = '') {
  const endpoint = endpointPattern.replace('{tenantCode}', tenantCodeLookup[tenantId]);
  const result = await http.get(`${catalystBaseUrl}${endpoint}`);
  const { responseBody } = result || {};
  if (!responseBody || !responseBody.data || !responseBody.data.politicalId) return {};
  const {
    data: { politicalId, latitude: lat, longitude: long },
  } = responseBody;
  return { politicalId, lat, long };
}

module.exports = getDefaultPoliticalIdWithLatLong;
